module.exports = __webpack_public_path__ + "static/img/weather_snow.67e990e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_snow.png
// module id = 6XN8
// module chunks = 2